import { createContext } from "react";
import { IMAGE_FORMATS } from "../utils/constants";
import { useDispatchApp } from "../lib/redux";
import { LaunchError } from "../utils/errors";
import {
  getKeyDatabase,
  saveUrl,
  startUploadFileAws,
} from "../services/public";
import { compressImage } from "../utils/string";

export const UploadFilesContext = createContext();

export const UploadFilesProvider = ({ children }) => {
  const dispatch = useDispatchApp();

  const uploadFile = async ({
    urlPreview,
    file,
    pathStorage,
    pathRTDB,
    doCompression = true,
    onCallbackLoading = () => {},
    modeUpload = "sync",
    disableVerificationMedia = false,
  }) => {
    try {
      onCallbackLoading(true);
      let newFile = file;
      if (!file) {
        onCallbackLoading(false);
        return;
      }
      const extension = file.type.split("/")[1];
      const isImage = IMAGE_FORMATS.includes(extension);

      if (doCompression && isImage) {
        newFile = await compressImage(file);
      }

      const url = await dispatch(
        startUploadFileAws(
          newFile,
          file.type,
          pathStorage,
          true,
          disableVerificationMedia
        )
      );

      if (!url) {
        onCallbackLoading(false);
        return;
      }

      if (pathRTDB) {
        if (modeUpload === "sync") {
          await dispatch(saveUrl(url, pathRTDB));
        } else {
          const key = dispatch(getKeyDatabase());
          const finalPath = `${pathRTDB}/${key}`;

          await dispatch(saveUrl(url, `${finalPath}/value`));
          await dispatch(saveUrl(urlPreview, `${finalPath}/preview`));
        }
      }

      onCallbackLoading(false);

      return url;
    } catch (error) {
      console.log(error);
      dispatch(
        LaunchError(error, true, [], {
          functionName: "uploadFile",
        })
      );
      onCallbackLoading(false);
      return false;
    }
  };

  return (
    <UploadFilesContext.Provider
      value={{
        uploadFile,
      }}
    >
      {children}
    </UploadFilesContext.Provider>
  );
};
